// Stores configuration for Google Maps API access

// IMPORTANT: For security, ensure this API key is restricted in Google Cloud Console
// using HTTP referrers (web site restrictions) to only allow requests from your app's domains.
// e.g., databutton.com (for workspace) and your deployed app domain (e.g., your-app.databutton.app).

// Get API key from environment variable
const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

// Validate that the API key exists
if (!apiKey) {
  console.error('❌ VITE_GOOGLE_MAPS_API_KEY is not defined in environment variables');
  throw new Error('Google Maps API key is missing. Please set VITE_GOOGLE_MAPS_API_KEY in your .env file');
}

export const GOOGLE_MAPS_API_KEY = apiKey;

// Define the libraries needed from Google Maps API, including 'places' for autocomplete
export const GOOGLE_MAPS_LIBRARIES: ( "places" | "drawing" | "geometry" | "localContext" | "visualization")[] = ["places"];
